import { useEventListener } from '@vueuse/core';

const seeOthersToggle = () => {
    const seeOthersButton: HTMLElement = document.getElementById('seeOtherButton');

    if (seeOthersButton) {
        useEventListener(seeOthersButton, 'click', () => {
            const otherAirdropsDiv = document.getElementById('otherAirdrops');
            const seeOthersSpan = document.getElementById('see-others');
            const hideOthersSpan = document.getElementById('hide-others');

            otherAirdropsDiv?.classList.toggle('d-none');
            seeOthersSpan?.classList.toggle('d-none');
            hideOthersSpan?.classList.toggle('d-none');
        });
    }
};

useEventListener(document, 'DOMContentLoaded', seeOthersToggle);
